/**
 * @Description
 */
export default {
  meta: {
    title: '工作台',
    url: '/expandstore/approver' // 埋点用，记录所属模块
  },
};

